<div class="search-area-container" #searchAreaContainer>
    <div class="search-bar">
        <div *ngIf="priceGroups && priceGroups.length > 0" class="price-group-dropdown">
            <p-dropdown [options]="priceGroups" [(ngModel)]="priceGroup" (onChange)="updateLineItemPricesByGroup()"
                placeholder="{{ 'bikeshop.workshop.jobcard.quote.apply_alternate_pricing' | translate }}">
            </p-dropdown>
        </div>
        <div class="search-bar-input">
            <hub-input name="quote-search-bar" id="quote-search-bar" #searchBar (input)="onSearchChange()" [(ngModel)]="searchProductTerm" [allowClear]="true"
                [iconColor]="'#888888'" [icon]="'search'"
                placeholder="{{'bikeshop.workshop.jobcard.quote.search' | translate }}"></hub-input>
        </div>
        <div *ngIf="hasPOSConnected">
            <hub-button [backgroundColor]="'#F4F3F3'" [icon]="'refresh'" [iconColor]="'#5D5D5D'" size="xl"
                [disabled]="syncingPOS" [loading]="syncingPOS"
                pTooltip="{{'bikeshop.workshop.jobcard.quote.sync_tooltip' | translate }}" tooltipPosition="bottom"
                (buttonClick)="syncProducts()" [style]="'borderless'"></hub-button>
        </div>

        <div *ngIf="canDoExternalSearch" class="ex-in-dropdown">
            <div class="custom-dropdown" [ngClass]="{ open: isExInOpen }" (click)="toggleDropdown()">
                <div class="selected-option">{{ selectedExInOption.label }} <span class="dropdown-icon">
                        <daz-icon *ngIf="!isExInOpen" [size]="'24px'" [color]="'#6D6D6D'"
                            [name]="'chevron-down'"></daz-icon>
                        <daz-icon *ngIf="isExInOpen" [size]="'24px'" [color]="'#6D6D6D'"
                            [name]="'chevron-up'"></daz-icon>
                    </span> </div>
                <ul class="dropdown-menu-options" *ngIf="isExInOpen">
                    <li *ngFor="let option of exInOptions" (click)="selectOption(option); $event.stopPropagation()"
                        [class.selected]="option.value === selectedExInOption.value">
                        <span>{{ option.label }}</span>
                        <daz-icon *ngIf="option.value === selectedExInOption.value" [name]="'check'" [size]="'20px'"
                            [color]="'#EE3158'"></daz-icon>
                    </li>
                </ul>
            </div>
        </div>

        <div *ngIf="canCreateSKU && selectedExInOption.value === 'INTERNAL'" class="add-product-button">
            <hub-button [backgroundColor]="'#F4F3F3'" [icon]="'grid-plus'" [iconColor]="'#5D5D5D'" size="xl"
                pTooltip="{{'bikeshop.pos_products.add_product_quote' | translate }}" tooltipPosition="bottom"
                [style]="'borderless'" (buttonClick)="createSKU()"></hub-button>
        </div>

    </div>

    <div class="collection-header-container" #collectionContainer *ngIf="selectedExInOption.value === 'INTERNAL'">
        <div class="collection-items" #collectionItems>
            <div *ngFor="let collection of visibleCollections" [ngClass]="{'selected': collection.selected}"
                (click)="collectionSelected(collection)" id="{{collection.id}}">
                <div>{{collection.collectionName}}</div>
                <div *ngIf="collection.count || collection.count >= 0" class="collection-badge">{{collection.count}}
                </div>
            </div>
            <!-- Overflow button -->
            <div *ngIf="overflowCollections.length >= 0 && !showCreateCollectionButton && visibleCollections.length > 0"
                class="overflow-button" (click)="showOverflow = !showOverflow">
                <div>+{{ overflowCollections.length }}</div>
                <div class="overflow-badge">
                    <daz-icon *ngIf="!showOverflow" [size]="'20px'" [name]="'chevron-down'"
                        [color]="'#060931'"></daz-icon>
                    <daz-icon *ngIf="showOverflow" [size]="'20px'" [name]="'chevron-up'" [color]="'#060931'"></daz-icon>
                </div>
                <div class="overflow-dropdown" *ngIf="showOverflow">
                    <div class="overflow-header">{{ 'bikeshop.workshop.jobcard.quote.select_a_collection' | translate}}
                    </div>
                    <div class="overflow-item-container">
                        <div>
                            <div *ngFor="let collection of (overflowCollections.length === 0 ? createdCollections : overflowCollections)"
                                (click)="collectionSelected(collection)">
                                <div>
                                    <div *ngIf="collection.count || collection.count === 0" class="collection-badge">
                                        {{collection.count}}</div>
                                    <div>{{collection.collectionName}}</div>
                                </div>
                                <div><hub-button [size]="'md'" [icon]="'chevron-right'"
                                        (buttonClick)="collectionSelected(collection)" [style]="'outline'"></hub-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-footer" (click)="manageCollections()">
                        <span><daz-icon [name]="'gear'" [size]="'20px'" [color]="'#5D5D5D'"></daz-icon></span>{{
                        'bikeshop.workshop.jobcard.quote.manage_collections' | translate}}
                    </div>
                </div>
            </div>
        </div>
        <div #createCollectionButton class="collection-button-container">
            <hub-button *ngIf="showCreateCollectionButton" [style]="'outline'"
                pTooltip="{{'bikeshop.workshop.jobcard.quote.create_a_collection' | translate}}"
                tooltipPosition="bottom" [icon]="'plus-alt'" [size]="'xl'"
                (buttonClick)="createCollection()"></hub-button>
            <hub-button *ngIf="showCreateCollectionButton" [style]="'outline'"
                pTooltip="{{'bikeshop.workshop.jobcard.quote.manage_collections' | translate}}" tooltipPosition="bottom"
                [icon]="'gear'" [size]="'xl'" (buttonClick)="manageCollections()"></hub-button>
        </div>
    </div>


    <div *ngIf="!hideSearchSummary && !isProductsloading && getFilteredSKUs().length === 0 && serviceTypeResults?.length === 0 && (selectedCollection === null || selectedCollection.id === 'ALL') && !(searchProductTerm && searchProductTerm.length > searchTriggerLength)"
        class="empty-state-content">
        <div *ngIf="!jobcard.id">
            <daz-icon [color]="'#EE3158'" [name]="'search'" [size]="'24px'" class="centre-icon"></daz-icon>
        </div>
        <div>
            <div class="empty-state-text">
                <div class="empty-state-header-text">{{(selectedExInOption.value == 'EXTERNAL' ?
                    'bikeshop.workshop.jobcard.quote.external_search_blurb_header' :
                    'bikeshop.workshop.jobcard.quote.search_blurb_header') |
                    translate}}
                </div>
                <div *ngIf="!jobcard.id">{{(selectedExInOption.value == 'EXTERNAL' ?
                    'bikeshop.workshop.jobcard.quote.external_search_blurb_text' :
                    'bikeshop.workshop.jobcard.quote.search_blurb_text') | translate}}</div>
            </div>
        </div>
    </div>

    <div *ngIf="!hideSearchSummary && !isProductsloading && getFilteredSKUs().length === 0 && serviceTypeResults?.length === 0 && selectedCollection !== null && selectedCollection.id !== 'ALL' && !(searchProductTerm && searchProductTerm.length > searchTriggerLength)"
        class="empty-state-content">
        <div>
            <daz-icon [color]="'#EE3158'" [name]="'search'" [size]="'24px'" class="centre-icon"></daz-icon>
        </div>
        <div>
            <div class="empty-state-text">
                <div class="empty-state-header-text">{{'bikeshop.workshop.jobcard.quote.empty_collection_blurb_header' |
                    translate}}
                </div>
                <div>{{'bikeshop.workshop.jobcard.quote.empty_collection_blurb_text' | translate}}</div>
            </div>
        </div>
    </div>

    <div *ngIf="!hideSearchSummary && !isProductsloading && getFilteredSKUs().length === 0 && serviceTypeResults?.length === 0 && searchProductTerm && searchProductTerm.length > searchTriggerLength"
        class="empty-state-content">
        <div>
            <div class="empty-state-text">
                <div>{{'bikeshop.workshop.jobcard.quote.empty_search_results_blurb_text' | translate}}</div>
            </div>
        </div>
    </div>

    <div *ngIf="isProductsloading"><app-workshop-jobcard-quote-search-loader></app-workshop-jobcard-quote-search-loader>
    </div>

    <!-- Service Type Results -->
    <div *ngIf="!isProductsloading && serviceTypeResults.length > 0" class="product-list-container floating-results service-type-results">
        <div class="floating-results-content" id="floating-results-content" name="floating-results-content">
            <div class="row header">
                <div class="col-12">{{serviceTypeResults.length}} {{ 
                    (serviceTypeResults.length === 1 ? 
                    'bikeshop.workshop.jobcard.quote.service_type' : 'bikeshop.menu.service_types') | translate }}
                </div>
            </div>
            <div class="service-type-list">
                <div *ngFor="let serviceType of serviceTypeResults" class="service-type-item" (click)="addServiceTypeToQuote(serviceType)">
                    <div class="service-type-header">
                        <div class="service-type-main">
                            <div class="group-name">{{serviceType.groupName}}</div>
                            <div class="service-name">{{serviceType.serviceType}}</div>
                        </div>
                        <div class="service-type-details">
                            <div class="hours" *ngIf="serviceType.hours">
                                {{getDurationFormatted(serviceType.hours)}}
                            </div>
                            <div class="price">{{ serviceType.totalPrice | currency: currencySymbol }}</div>
                        </div>
                    </div>
                    <div class="linked-skus" *ngIf="serviceType.linkedSKUs && serviceType.linkedSKUs.length > 0">
                        <div class="sku-label">{{ 'bikeshop.workshop.jobcard.quote.linked_products' | translate }}:</div>
                        <div class="sku-list">
                            <span *ngFor="let sku of serviceType.linkedSKUs; let last = last" class="sku-item">
                                {{sku.name || sku.sku}}<span *ngIf="!last">, </span>
                            </span>
                        </div>
                    </div>
                    <div class="no-linked-skus" *ngIf="!serviceType.linkedSKUs || serviceType.linkedSKUs.length === 0">
                        <span class="no-products-text">{{ 'bikeshop.workshop.jobcard.quote.no_linked_products' | translate }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Regular Product Results -->
    <div *ngIf="!isProductsloading && getFilteredSKUs().length > 0" class="product-list-container floating-results">
        <div class="floating-results-content">
            <div class="row header">
                <div class="col-6" [ngClass]="{'col-8' : !canGetQuantitiesFromPOS()}">{{getFilteredSKUs().length}} {{
                    (getFilteredSKUs().length === 1 ?
                    'bikeshop.workshop.jobcard.quote.result' : 'bikeshop.workshop.jobcard.quote.results') | translate }}
                </div>
                <div class="col-2 right-aligned" *ngIf="canGetQuantitiesFromPOS()">
                    <span class="get-quantities-icon" (click)="getSearchResultQuantities()">
                        <daz-icon *ngIf="lineItemResults.length < 100" [spin]="getQuantitiesLocked" [name]="'refresh'"
                            [size]="'16px'" [color]="'#888888'"
                            pTooltip="{{ 'bikeshop.modal.update_job_card.quote.get_quantities_allowed_new' | translate }}"
                            tooltipPosition="bottom"></daz-icon>
                        <daz-icon *ngIf="lineItemResults.length >= 100" [name]="'refresh'" [size]="'16px'"
                            [color]="'#df2323'"
                            pTooltip="{{ 'bikeshop.modal.update_job_card.quote.get_quantities_blocked' | translate }}"
                            tooltipPosition="bottom"></daz-icon>
                    </span>
                    {{ 'bikeshop.inventory_audit.quantity' | translate }}
                </div>
                <div class="col-2 right-aligned"> {{ 'bikeshop.print.price' | translate }}</div>
                <div class="col-2"></div>
            </div>
            <div class="product-list">
                <div *ngFor="let sku of getFilteredSKUs()" class="row product-item" (click)="addToQuote(sku)">
                    <div class="col-6 name" [ngClass]="{'col-8' : !canGetQuantitiesFromPOS()}">
                        <div>{{sku.Name}}</div>
                        <div>{{sku.SKU}}</div>
                    </div>
                    <div class="col-2 right-aligned" *ngIf="canGetQuantitiesFromPOS()">{{sku.StockOnHand}}</div>
                    <div class="col-2 right-aligned price">{{(vatInclusive ? sku.UnitPrice_IncludingTax : sku.UnitPrice)
                        |
                        currency: currencySymbol}}</div>
                    <div class="col-2 right-aligned actions">
                        <hub-button *ngIf="!isInCustomCollection()" text="{{ 'bikeshop.general.save' | translate }}"
                            [size]="'sm'" [disabled]="selectedExInOption.value == 'EXTERNAL'"
                            [style]="'borderless-secondary'" (buttonClick)="addToCollection($event, sku)"></hub-button>
                        <hub-button *ngIf="selectedExInOption.value == 'INTERNAL' && isInCustomCollection()"
                            text="{{ 'bikeshop.workshop.jobcard.manage.attachments.remove' | translate }}" [size]="'sm'"
                            [disabled]="selectedExInOption.value == 'EXTERNAL'" [style]="'borderless-secondary'"
                            (buttonClick)="removeFromCollection($event, sku)"></hub-button>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>

<p-toast position="bottom-center" styleClass="hubtiger-jobcard-toast"></p-toast>

<p-sidebar #NavSideBar [(visible)]="showCreatePOSProduct" position="right" [dismissible]="true" [closeOnEscape]="true"
    styleClass="custom-sidebar" [appendTo]="'body'"
    [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="NavSideBar.destroyModal()">
    <div *ngIf="showCreatePOSProduct">
        <app-product-add-edit [product]="{}" (close)="showCreatePOSProduct = false"
            (update)="posProductCreated($event)"></app-product-add-edit>
    </div>
</p-sidebar>